/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useEffect, useState} from 'react';
import {ReactComponent as SearchIcon} from "../assets/img/icons/search.svg";
import {ReactComponent as ArrowRight} from "../assets/img/icons/arrow-right-white.svg";
import useAxiosJTW from "../Hooks/useAxiosJTW";
import Loader from "../elements/loader";
import {useNavigate, useParams} from "react-router-dom";
import {useForm} from "react-hook-form";
import ModelPartsForm from "./ModelPartsForm";
import {useTranslation} from "react-i18next";

const SearchByModel = (props) => {

    const axiosJWT = useAxiosJTW();
    const { t, i18n } = useTranslation();
    let navigate = useNavigate();

    let params = useParams();
    const queryParameters = new URLSearchParams(window.location.search);
    const _bodytype = queryParameters.get("bodytype");
    const _spec = queryParameters.get("spec");

    const [trigger, setTrigger] = useState();

    const [makes, setMakes] = useState({isLoading: false, data: [], error: false});
    const [models, setModels] = useState({isLoading: false, data: [], error: false});
    const [typeStage, setTypeStage] = useState({isLoading: false, data: [], error: false});
    const [yearRangeStage, setYearRangeStage] = useState({isLoading: false, data: [], error: false});

    const { register, handleSubmit, watch, formState: { errors }, reset, setValue, getValues } = useForm({
        mode: "onChange"
    });

    const watchMakes = watch("makes", false);
    const watchModels = watch("models", false);
    const watchType = watch("type", false);

    const getpartslistingbypartsearchfilter =  (signal) => {
        axiosJWT.post('api/getpartslistingbypartsearchfilter', { page: 1, make: params.make, model: params.model, part: params.part, bodytype: _bodytype, year: params.year, spec: _spec },{signal}).then( (response) => {
            if(response.status === 200){
                if(response.data.success){

                    setMakes({...makes, data: response.data.makes|| [], isLoading: false});
                    setModels({...models, data: response.data.models|| [], isLoading: false});
                    setTypeStage({...typeStage, data: response.data.types || [], isLoading: false});
                    setYearRangeStage({...yearRangeStage, data: response.data.date_range || [], isLoading: false});
                    setTrigger(true);
                }else{
                    setModels({...models, data: [], isLoading: false});
                    setTypeStage({...typeStage, data: [], isLoading: false});
                    setYearRangeStage({...yearRangeStage, data: [], isLoading: false});
                }
            }
        } ).catch((error) => {
            console.log(error);
        });
    }

    const getallmakes = (signal) => {
        axiosJWT.post('api/getallmakes', { part_title: params.part },{signal}).then( (response) => {
            if(response.status === 200){
                setMakes({...makes, data: response.data.makes|| [], isLoading: false});
            }
        } ).catch((error) => {
            console.log(error);
            setMakes({...makes, error: true});
        });
    }
    const getmodelsbymake = (data) => {
        axiosJWT.post('api/getmodelsbymake', { make: data,  }).then( (response) => {
            if(response.status === 200){
                setModels({...models, data: response.data.models|| [], isLoading: false});
            }
        } ).catch((error) => {
            console.log(error);
            setModels({...models, error: true});
        });
    }
    const getTypeByModel = (model) => {
        axiosJWT.post('api/gettypebymodel', { model: model }).then( (response) => {
            if(response.status === 200){
                setTypeStage({...typeStage, data: response.data.types || [], isLoading: false});
            }
        } ).catch((error) => {
            console.log(error);
        });
    }
    const getModelDatesRange = (model, data) => {
        axiosJWT.post('api/getmodeldatesrange', { model: model, type: data[0], doors: data[1] }).then( (response) => {
            if(response.status === 200){
                setYearRangeStage({...yearRangeStage, data: response.data.date_range || [], isLoading: false});
            }
        } ).catch((error) => {
            console.log(error);
        });
    }

    const onMakeSelect = (data) =>{
        setValue('models', '');
        setValue('type', '');
        setValue('yearRange', '');

        setValue('makes', data);
        setModels({...models, isLoading: true});
        getmodelsbymake(data);
    }
    const onModelSelect = (data) =>{
        setValue('type', '');
        setValue('yearRange', '');

        setValue('models', data);
        setTypeStage({...typeStage, isLoading: true});
        getTypeByModel(data);
    }
    const onTypeSelect = (data) =>{
        setValue('yearRange', '');

        const _model = getValues('models');
        setValue('type', data);

        const _data = data.split(',');
        setYearRangeStage({...yearRangeStage, isLoading: true});
        getModelDatesRange(_model, _data);
    }

    const onSubmit = (data) => {
        props.search(data);
    }

    useEffect(() => {
        const controller = new AbortController();
        const signal= controller.signal;

        if(!_bodytype){
            getallmakes(signal);
        }

        return () => {controller.abort();}
    }, [params]);

    useEffect(() => {
        const controller = new AbortController();
        const signal= controller.signal;

        getpartslistingbypartsearchfilter(signal);

        return () => {controller.abort();}
    }, []);

    useEffect(() => {
        if(_bodytype){
            setValue('makes', params.make);
            setValue('models', params.model);
            setValue('type', _bodytype);
            setValue('yearRange', params.year);
        }

    }, [trigger]);

    return (
        <div className='searchByModel'>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row align-items-center small-gutters">
                    <div className="col-lg-auto">
                        <div className='searchByModel__header-row mb-3 mb-lg-0'>
                            <div className='searchByModel__icon'><SearchIcon/></div>
                            {/*<div className='searchByModel__label'>Search by Part</div>*/}
                        </div>
                    </div>
                    <div className="col-md">
                        <div className="row align-items-center small-gutters">
                            <div className="col-md-3">
                                <div className="position-relative">
                                    {makes.isLoading ? (
                                        <div className='small' style={{ position: 'absolute', top : '-22px' }}><Loader/></div>
                                    ) : (
                                        <select className='select-by-element form-control' defaultValue='' {...register("makes", {required: 'Required Field'})} onChange={ (e) => {onMakeSelect(e.target.value)} }>
                                            <option value="" disabled>{t('fields.selectMake')}</option>
                                            { makes.data.map((option, i) => <option key={i} value={option.slug}>{option.title}</option>)}
                                        </select>
                                    )}
                                    { errors.makes && <small className="text-danger">{errors.makes?.message}</small>}
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="position-relative">
                                    {models.isLoading ? (
                                        <div className='small' style={{ position: 'absolute', top : '-22px' }}><Loader/></div>
                                    ) : (
                                        <select className='select-by-element form-control' defaultValue='' disabled={!watchMakes} {...register("models", {required: 'Required Field'})} onChange={ (e) => {onModelSelect(e.target.value)} }>
                                            <option value="" disabled>{t('fields.selectModel')}</option>
                                            {models.data.map((option, i) => <option key={i} value={option.model_name}>{option.model_name}</option>)}
                                        </select>
                                    )}
                                    { errors.models && <small className="text-danger">{errors.models?.message}</small>}
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="position-relative">
                                    {typeStage.isLoading ? (
                                        <div className='small' style={{ position: 'absolute', top : '-22px' }}><Loader/></div>
                                    ) : (
                                        <select className='select-by-element form-control' disabled={!watchModels} defaultValue="" {...register("type", {required: 'Required Field'})} onChange={ (e) => {onTypeSelect(e.target.value)} }>
                                            <option value="" disabled>{t('fields.selectType')}</option>
                                            {typeStage.data.map((option, i) => <option key={i} value={[option.body_type_id, option.doors]}>{option.title} / {option.doors}</option>)}
                                        </select>
                                    )}
                                    { errors.type && <small className="text-danger">{errors.type?.message}</small>}
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="position-relative">
                                    {yearRangeStage.isLoading ? (
                                        <div className='small' style={{ position: 'absolute', top : '-22px' }}><Loader/></div>
                                    ) : (
                                        <select className='select-by-element form-control' disabled={!watchType} defaultValue="" {...register("yearRange", {required: 'Required Field'})}>
                                            <option value="" disabled>{t('fields.selectYear')}</option>
                                            {yearRangeStage.data.map((option, i) => <option key={i} value={option.url}>{option.title}</option>)}
                                        </select>
                                    )}
                                    { errors.yearRange && <small className="text-danger">{errors.yearRange?.message}</small>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-auto">
                        <button className='btn btn-primary btn-icon btn-icon-right ml-auto ml-lg-0 mt-4 mt-lg-0'>
                            {t('parts.topSearch')}
                            <ArrowRight/>
                        </button>
                    </div>
                </div>
                { (makes.error || models.error || yearRangeStage.error) && <div className='pt-3 text-center'>
                    <small className="text-danger">An error occurred please try again later</small>
                </div> }

            </form>
        </div>
    );
};

export default SearchByModel;
